<div class="py-5">
  <x-markdown-view *ngIf="_content" [source]="_content.content"></x-markdown-view>
</div>
